/* eslint-disable no-nested-ternary */
import React from "react";

import { useFieldsLabels } from "app/hooks";
import { Trans } from "app/utils";

import UserThumbnail from "components/person/UserThumbnail";

const MAX_USERS_TO_SHOW = 6;

const SelectedUsers = ({ selectedUsers }) => {
  const labels = useFieldsLabels();

  const getDepartmentsArray = () => {
    let departments = [];
    selectedUsers.forEach(user => {
      departments = [...departments, ...user.departments.map(department => department.id)];
    });
    return [...new Set(departments)];
  };

  const getLocationsArray = () => {
    const locations = selectedUsers.filter(user => !!user.location).map(user => user.location.id);
    return [...new Set(locations)];
  };
  const departments = getDepartmentsArray();
  const locations = getLocationsArray();
  return (
    <div className="ApproveProfileModal__SelectedUsers">
      {selectedUsers.map((user, index) => (
        index < MAX_USERS_TO_SHOW && <UserThumbnail key={user.id} user={user} />
      ))}
      {selectedUsers.length > MAX_USERS_TO_SHOW && <span className="ApproveProfileModal__SelectedUsers__more Thumbnail">+{selectedUsers.length - MAX_USERS_TO_SHOW}</span>}
      <span className="ApproveProfileModal__SelectedUsers__description">
        <strong>{selectedUsers.length} user{selectedUsers.length > 1 ? "s" : ""}</strong>
        {" "}
        <Trans>selected across</Trans>
        {" "}
        <strong>{departments.length}
          {" "}
          {(departments.length === 1
            ? labels.departments.singular : labels.departments.plural).toLowerCase()}
        </strong>
        {" "}
        <Trans>and</Trans>
        {" "}
        <strong>{locations.length} location{locations.length > 1 ? "s" : ""}</strong>
      </span>
    </div>
  );
};

export default SelectedUsers;
